import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

const getStyles = (theme) => (
  {
    root: {
      position: 'fixed',
      zIndex: 3,
      left: 0,
      top: 0,
      width: '100%',
      height: '65px !important'
    },
    toolBar: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      boxSizing: 'border-box',
      padding: '0 6rem'
    },
    contentTitle: {
      textDecoration: 'none',
      position: 'relative',
      height: 48
    },
    title: {
      position: 'absolute',
      top: 0,
      left: 0,
      fontSize: '3rem  !important',
      fontWeight: '600 !important',
      lineHeight: '1 !important',
      letterSpacing: '-7px !important',
      fontFamily: '"M PLUS 1 Code", sans-serif !important',
      color: theme.palette?.primary.main
    },
    activeIcon: {
      color: `${theme.palette?.primary.main} !important`
    },
    btnGroupActive: {
      marginLeft: '16px !important'
    },

    showBtn: {
      marginLeft: '80px !important',
      [theme.breakpoints?.down('sm')]: {
        display: 'none !important'
      }
    },
    showIcon: {
      marginLeft: '50px !important',
      backgroundColor: theme.palette?.primary.main + ' !important',

      [theme.breakpoints?.up('sm')]: {
        display: 'none !important'
      }
    },
    showIconMap: {
      [theme.breakpoints?.up('sm')]: {
        display: 'none !important'
      }
    }

  }
)
const PREFIX = 'ToolBarStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const ToolBarStyle = styled(Box)(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  ToolBarStyle
}
